type Func<A, R> = (...args: A[]) => R;

export const compose = <T>(...funcs: Func<any, T>[]): Func<any, T> =>
  funcs.reduce(
    (a, b) =>
      (...args) =>
        a(b(...args)),
    (arg) => arg
  );
